import hero from '@namespace/top/hero'
import gallery from '@namespace/top/gallery'
import video from '@namespace/top/video'

export default function top() {
  window.addEventListener('load', () => {
    hero()
    gallery()
    video()
  })
}
